import { styled } from '@customink/pigment-react/lib/themeCustomink';
import { IconButton } from '@mui/material';

export const IconButtonBlack = styled(IconButton)(({ theme }) => ({
    color: theme.palette.text.primary,
}));
